import { ReactNode } from "react";

import { BaseTreeListItemProps } from "../types";

type TreeListNodeItemProps<T extends object> = BaseTreeListItemProps<T> & {
  renderItem: (option: BaseTreeListItemProps<T>) => ReactNode;
};

const TreeListNodeItem = <T extends object>({
  renderItem,
  ...itemProps
}: TreeListNodeItemProps<T>) => {
  return renderItem(itemProps);
};

TreeListNodeItem.displayName = "DS.TreeList.NodeItem";

export default TreeListNodeItem;
